import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";

import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { BlogData} from "@/services/api/cresivoxServer";


import { REDUCER_NAME  } from "./Types";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);




export const addBlogData = createAsyncThunk<
  iGenericResponse<any | null>,
  FormData, // ✅ changed
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("addBlogData"),
  // @ts-expect-error
  async (body, { rejectWithValue }) => {
    try {
      const response = await BlogData.addBlogData(body);

      if (response) {
        const { httpStatusCode, data, message } = response;

        if (httpStatusCode === httpStatusCodes.SUCCESS_OK && data?.data) {
          return {
            data: data.data,
            message,
          };
        }

        return rejectWithValue({
          httpStatusCode,
          message,
        });
      }

      return rejectWithValue({
        message: "No response received",
      });
    } catch (error) {
      console.error("🚀 ~ error:", error);
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);



export const getBlogData = createAsyncThunk<
  iGenericResponse<any | null>,
  void,
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("getBlogData"),
  // @ts-expect-error
  async (_, { rejectWithValue }) => {
    try {
      const response = await BlogData.getBlogData();

      if (!response) {
        return rejectWithValue({
          message: "No response received",
        });
      }

      const { httpStatusCode, data, message } = response;

      const dataValue = data?.data || [];
      if (httpStatusCode === httpStatusCodes.SUCCESS_OK) {
        return {
          data: dataValue,
          message,
        };
      }

      return rejectWithValue({
        httpStatusCode,
        message,
      });
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);


export const deleteBlogData = createAsyncThunk<
  iGenericResponse<any | null>,
  string, // blog id
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("deleteBlogData"),
  // @ts-expect-error
  async (id, { rejectWithValue }) => {
    try {
      const response = await BlogData.deleteBlogData(id);

      if (response) {
        const { httpStatusCode, data, message } = response;

        if (httpStatusCode === httpStatusCodes.SUCCESS_OK) {
          return {
            data: id, // returning deleted id
            message,
          };
        }

        return rejectWithValue({
          httpStatusCode,
          message,
        });
      }

      return rejectWithValue({
        message: "No response received",
      });
    } catch (error) {
      console.error("🚀 ~ delete error:", error);
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);